"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.win = win;
function win() {
    return window.window; // Это тут написано чтобы обойти баг антивируса ESET 2014 который ругался если видел строку 'a = window;' (KEF-261)
}
